(function () {
	"use strict";

	angular
		.module("trakeyeApp")
		.controller("CaseImportController", CaseImportController);

	CaseImportController.$inject = ["CaseImportList", "Report"];

	function CaseImportController(CaseImportList, Report) {

		var vm = this;

		vm.page = 1;
		vm.itemsPerPage = 10;
		vm.totalItems = 0;
		vm.displayList = [];
		vm.expandResponse = null;

		// ===== LOAD DATA =====
		vm.loadData = function () {

			var pageToSend = vm.page - 1;
			CaseImportList.get(pageToSend, vm.itemsPerPage, 'id,desc', function (data, headers) {
				vm.displayList = data;
				vm.totalItems = headers('X-Total-Count');
			});
		};

		// ===== PAGE CHANGE =====
		vm.loadPage = function (page) {
			vm.page = page;
			vm.loadData();
		};

		// ===== REFRESH =====
		vm.refresh = function () {
			vm.page = 1;
			vm.loadData();
		};

		// ===== INITIAL LOAD =====
		vm.loadData();

		// ===== EXPAND =====
		vm.expand = function (entity) {

			vm.displayList.forEach(function (item) {
				item.expand = false;
			});

			if (vm.toggle === entity.id) {
				vm.toggle = undefined;
			} else {
				entity.expand = true;
				vm.toggle = entity.id;

				vm.expandResponse = null;

				Report.getEntityDetails(entity.id, function (response) {
					vm.expandResponse = response;
				});
			}
		};

		// ===== DOWNLOAD =====
		vm.download = function (imgId, id, name) {
            var temp = "Report"
			Report.downloadZip(id, imgId, function (data) {
				var a = document.createElement("a");
                var file = new Blob([data], { type: 'application/xlsx' });

                var fileURL = URL.createObjectURL(file);
                a.href = fileURL;
                a.download = name ? name : temp + ".xlsx";
				a.click();
                window.URL.revokeObjectURL(fileURL);
            })
        }
	}
})();
